import { action, computed, observable, makeObservable } from 'mobx';
import {ContentLookup, contentLookupService, VersionedContentLookup} from '../../../../domain';
import {PromiseState} from '../../../../lib/helpers';

export class ContentLookupStore {
  @observable.ref
  lookupState: PromiseState<VersionedContentLookup> | null;

  constructor() {
    makeObservable(this);
    this.lookupState = null;
  }

  @computed
  get lookup(): ContentLookup | null {
    if (this.lookupState?.isResolved === true)
      return this.lookupState.value.lookup;
    return null;
  };

  @action
  load = () => {
    if (this.lookupState?.isPending === true)
      return;
    this.lookupState = contentLookupService.load();
  };
}
